let Hooks = {}

// Opens to the right, and flips left only when that would run off the page.
Hooks.CapabilityMenu = {
    mounted() {
        this.place()
        this.onResize = () => this.place()
        window.addEventListener("resize", this.onResize)
    },

    updated() {
        this.place()
    },

    destroyed() {
        window.removeEventListener("resize", this.onResize)
    },

    place() {
        this.el.classList.remove("flip-left")
        const margin = 8
        if (this.el.getBoundingClientRect().right > document.documentElement.clientWidth - margin) {
            this.el.classList.add("flip-left")
        }
    }
}

Hooks.SiteResetPassword = {
    mounted() {
        const component = this;
        addEventListener("resize", function () {
            component.resize()
        });
        window.addEventListener("sa_cloud:copy_token", (event) => {
            component.copy()
        });
        this.resize();
    },

    resize() {
        const area = document.getElementById('token')
        const splitEvery = Math.round(area.offsetWidth / 10);
        const regex = new RegExp(`.{1,${splitEvery}}`, 'g');
        const lines = area.value.replace(/\n/g, '').match(regex)
        area.value = lines.join("\n")
        area.rows = lines.length
        area.style.visibility = "visible";
    },

    copy() {
        if ("clipboard" in navigator) {
            const area = document.getElementById('token');
            const link = document.getElementById('copy-link');
            area.select();
            area.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(area.value);
            window.getSelection().removeAllRanges();
            link.innerHTML = "Text has been copied to clipboard"
        } else {
            alert("Sorry, your browser does not support clipboard copy.");
        }
    }
}
export {Hooks}